import Divider from '@mui/material/Divider';
import { FormElementProps } from 'components/common/form';

export default function FormStaticDivider({ elementProps }: { elementProps: FormElementProps }) {
    //ToDo [Stas]: review and fix vertical orientation

    const { orientation, indentTop, indentBottom, indentLeft, indentRight } = elementProps.componentProps;

    return (
        <Divider
            orientation={orientation}
            flexItem
            sx={
                orientation == 'vertical'
                    ? {
                          ml: indentLeft,
                          mr: indentRight,
                      }
                    : {
                          mt: indentTop,
                          mb: indentBottom,
                      }
            }
        />
    );
}
